module.exports = __webpack_public_path__ + "img/reset-roster-confirmation.97329d3d.png";